(function () {
  "use strict";

  var SIDEBAR_SELECTOR = ".leftColumn.aside, .rightColumn.aside";
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // jQuery's own global switch for instant (no-animation) effects. Doing this
  // here means slideUp/slideDown calls made by the protected theme.js bundle
  // become instant too, without editing that file.
  if (reduceMotion && window.jQuery) {
    window.jQuery.fx.off = true;
  }

  function syncAccordionState(collapseEl) {
    var title = collapseEl.querySelector(":scope > .tt-collapse-title");
    if (!title) return;
    var isOpen = collapseEl.classList.contains("open");
    title.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }

  function initAccordionSync() {
    var sidebars = document.querySelectorAll(SIDEBAR_SELECTOR);
    if (!sidebars.length) return;

    sidebars.forEach(function (sidebar) {
      // Keep aria-expanded correct even though the actual open/close class
      // toggle happens inside the protected theme.js click handler.
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            var target = mutation.target;
            if (target.classList && target.classList.contains("tt-collapse")) {
              syncAccordionState(target);
            }
          }
        });
      });
      observer.observe(sidebar, {
        attributes: true,
        attributeFilter: ["class"],
        subtree: true
      });

      // Re-run whenever the AJAX filter engine swaps content back in.
      sidebar.querySelectorAll(".tt-collapse").forEach(syncAccordionState);
    });

    // The AJAX filter response can replace filter lists; give the new nodes
    // an initial aria-expanded pass too (the observer above only fires on
    // future class changes, not on nodes that arrive already carrying the
    // "open" class from server-rendered markup).
    document.body.addEventListener("listingpageajax", function () {
      document.querySelectorAll(SIDEBAR_SELECTOR + " .tt-collapse").forEach(syncAccordionState);
    });
  }

  function isAccordionHeading(el) {
    return el && el.classList && el.classList.contains("tt-collapse-title") && el.closest(SIDEBAR_SELECTOR);
  }

  function initAccordionKeyboard() {
    // Event delegation: survives the AJAX engine replacing filter markup,
    // and doesn't add a second click handler (Enter/Space are dispatched as
    // a real click, which the existing protected handler already owns).
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " " && e.key !== "Spacebar") return;
      if (!isAccordionHeading(e.target)) return;
      e.preventDefault();
      e.target.click();
    });
  }

  function getFocusable(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return el.offsetParent !== null;
    });
  }

  function initMobileDrawer() {
    var drawer = document.getElementById("tt-filter-drawer");
    var trigger = document.querySelector(".tt-btn-toggle a");
    if (!drawer || !trigger) return;

    var lastFocused = null;

    function isOpen() {
      return drawer.classList.contains("column-open");
    }

    function onKeydown(e) {
      if (!isOpen()) return;
      if (e.key === "Escape" || e.key === "Esc") {
        e.preventDefault();
        var closeBtn = drawer.querySelector(".tt-btn-col-close a");
        if (closeBtn) closeBtn.click();
        return;
      }
      if (e.key === "Tab") {
        var focusable = getFocusable(drawer);
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    document.addEventListener("keydown", onKeydown);

    var observer = new MutationObserver(function () {
      var open = isOpen();
      trigger.setAttribute("aria-expanded", open ? "true" : "false");

      if (open) {
        drawer.setAttribute("role", "dialog");
        drawer.setAttribute("aria-modal", "true");
        lastFocused = document.activeElement;
        var focusable = getFocusable(drawer);
        var closeBtn = drawer.querySelector(".tt-btn-col-close a");
        (closeBtn || focusable[0] || drawer).focus();
      } else {
        drawer.removeAttribute("role");
        drawer.removeAttribute("aria-modal");
        if (lastFocused && typeof lastFocused.focus === "function") {
          lastFocused.focus();
        }
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ["class"] });
  }

  function initPriceSliderKeyboard() {
    // The scrollwidget drag-handle buttons only wire up mousedown/touchstart
    // in price_range_widget.s.min.js - focusable but inert on a keyboard.
    // Drive the paired number input instead: the widget already listens for
    // input/change on those fields and repositions the handle + debounces
    // the AJAX update itself, so dispatching real events here is enough.
    document.addEventListener("keydown", function (e) {
      var btn = e.target.closest && e.target.closest('[class*="scrollwidget_scroll_btn"]');
      if (!btn) return;

      var widget = btn.closest(".scrollwidget");
      if (!widget) return;
      var inputs = widget.querySelectorAll("input");
      if (!inputs.length) return;
      var isLeft = btn.classList.contains("scrollwidget_scroll_btn__left");
      var input = isLeft ? inputs[0] : inputs[inputs.length - 1];

      var min = Number(widget.getAttribute("data-min")) || 0;
      var max = Number(widget.getAttribute("data-max")) || 0;
      var step = Math.max(1, Math.round((max - min) / 100));
      var current = Number(input.value) || 0;
      var next = null;

      switch (e.key) {
        case "ArrowRight":
        case "ArrowUp":
          next = Math.min(max, current + step);
          break;
        case "ArrowLeft":
        case "ArrowDown":
          next = Math.max(min, current - step);
          break;
        case "Home":
          next = min;
          break;
        case "End":
          next = max;
          break;
        default:
          return;
      }

      e.preventDefault();
      input.value = next;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ready);
  } else {
    ready();
  }

  function ready() {
    initAccordionSync();
    initAccordionKeyboard();
    initMobileDrawer();
    initPriceSliderKeyboard();
  }
})();
